module.exports = __webpack_public_path__ + "img/1028.7fac3f8a.jpg";